module.exports = __webpack_public_path__ + "fonts/lato-regular.8c4d18a.woff2";